<template>
  <span class="spinner">
    Loading
    <span class="cursor"></span>
  </span>
</template>

<script>
  /**
   * This component prints a blinking cursor, indicating some loading process.
   */
  export default {
    name: 'Spinner'
  }
</script>

<style scoped lang="scss" src="./Spinner.scss"/>
